<template>
    <div>
        <b-modal id="modal-contact" class="maintenance_modal" centered :footer-class="'d-block p-3 m-0'"
            scrollable :body-class="'px-3 pt-2 '">
            <template #modal-header="{ close }">
                <h5 class="modal-title"> {{ contactData ? $t('safetyContacts.editTitle') : $t('safetyContacts.addTitle') }}
                </h5>
                <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                    Close Modal
                </b-button>
            </template>
            <div class="d-block text-center">
                <b-row>
                    <b-col sm="12" class="text-left">
                        <b-form-group>
                            <label class="state">{{ $t('safetyContacts.nameLabel') }}</label>
                            <b-form-input type="text" v-model="contactPayload.name" class="f-12" :placeholder="$t('safetyContacts.namePlaceholder')"
                                :disabled="!allowUpdateRecord"></b-form-input>
                            <p v-if="errors && errors.name" class="field-error">
                                {{ errors.name[0] }}
                            </p>
                        </b-form-group>
                        <b-form-group>
                            <label class="state">{{ $t('safetyContacts.roleLabel') }}</label>
                            <b-form-input type="text" v-model="contactPayload.role" class="f-12" :placeholder="$t('safetyContacts.rolePlaceholder')"
                                 :disabled="!allowUpdateRecord"></b-form-input>
                        </b-form-group>
                        <b-form-group>
                            <label class="state">{{ $t('safetyContacts.phoneLabel') }}</label>
                            <b-input-group size="lg" class="w-100" prepend="+1">
                                <b-form-input v-mask="phoneMask" class="f-12" v-model="contactPayload.phone"
                                    :disabled="!allowUpdateRecord"></b-form-input>
                            </b-input-group>
                            <p v-if="errors && errors.phone" class="field-error">
                                {{ errors.phone[0] }}
                            </p>
                        </b-form-group>
                        <b-form-group>
                            <label class="state">{{ $t('safetyContacts.emailLabel') }}</label>
                            <b-form-input type="text" v-model="contactPayload.email" class="f-12" :placeholder="$t('safetyContacts.emailPlaceholder')"
                                :disabled="!allowUpdateRecord"></b-form-input>
                            <p v-if="errors && errors.email" class="field-error">
                                {{ errors.email[0] }}
                            </p>
                        </b-form-group>
                        <b-form-group v-if="accidentalContact">
                            <label class="state">{{ $t('safetyContacts.injuryStatusLabel') }}</label>
                            <b-form-select class="f-12" :options="injuryStatusOptions" v-model="contactPayload.injury_status" :disabled="!allowUpdateRecord">
                            </b-form-select>
                        </b-form-group>
                        <b-form-group v-if="accidentalContact">
                            <label class="state">{{ $t('safetyContacts.ambulanceLabel') }}</label>
                            <b-form-select class="f-12" :options="ambulanceOptions" v-model="contactPayload.ambulance" :disabled="!allowUpdateRecord">
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>
            </div>
            <template #modal-footer>
                <div class="text-right modal-footer border-0 p-0">
                    <b-button class="mt-3 mr-3 btn cancel m-0" block @click="resetPopup()">{{ $t('safetyShared.cancel') }}</b-button>
                    <div class="d-flex align-items mt-3 m-0">
                        <b-button class="btn save mx-0 w-100" variant="primary" @click="onAddContact"
                            v-if="allowUpdateRecord">{{ $t('safetyShared.save') }}</b-button>
                    </div>
                </div>
            </template>
        </b-modal>
    </div>
</template>
<script>
import { mapActions } from 'vuex';
import { checkEmail, checkPhoneFormat } from '../../services/helper';
export default {
    name: "Contacts",
    props: ["id", "contactData", "addContact", 'updateContact', 'allowUpdateRecord', "accidentalContact"],
    data() {
        return {
            errors: {},
            checkEmail,
            checkPhoneFormat,
            roleItems: [],
            contactPayload: {
                name: "",
                role: "",
                phone: "",
                email: "",
                injury_status: "-",
                ambulance: null
            },
        }
    },
    computed: {
        injuryStatusOptions() {
            return [
                { value: '-', text: '-' },
                { value: 'INJ', text: this.$t('safetyContacts.injury') },
                { value: 'FAT', text: this.$t('safetyContacts.fatality') },
            ];
        },
        ambulanceOptions() {
            return [
                { value: null, text: '-' },
                { value: true, text: this.$t('safetyContacts.yes') },
                { value: false, text: this.$t('safetyContacts.no') },
            ];
        },
        phoneMask() {
            return this.contactPayload?.phone?.length > 0
                ? [
                    /\d/, /\d/, /\d/, " ",
                    /\d/, /\d/, /\d/, " ",
                    /\d/, /\d/, /\d/, /\d/
                ]
                : false; // Allows empty input
        },
    },
    methods: {
        ...mapActions(['setNotification', 'setLoader', 'getUserRoles']),
        resetPopup() {
            this.errors = {}
            this.contactPayload = {
                name: "",
                role: "",
                phone: "",
                email: "",
                injury_status: "-",
                ambulance: null
            }
            this.$emit("popupClose")
            this.$bvModal.hide("modal-contact");
        },
        checkNullValues(payload) {
            let nullKeys = [];
            for (let [key, value] of Object.entries(payload)) {
                if (!value) {
                    nullKeys.push(key);
                }
            }
            return nullKeys;
        },
        async onAddContact() {
            try {
                if (this.contactPayload.email) {
                    if (!this.checkEmail(this.contactPayload.email)) {
                        throw {
                            email: [this.$t('safetyShared.wrongFormat')],
                        };
                    }
                }
                const nullKeys = this.checkNullValues({
                    name: this.contactPayload.name
                });
                if (this.contactPayload.phone) {
                    if (!this.checkPhoneFormat(this.contactPayload.phone)) {
                        throw {
                            phone: [this.$t('safetyShared.wrongFormat')],
                        };
                    }
                }
                if (nullKeys.length === 0) {
                    this.setLoader(true)
                    let successMsg = this.$t('safetyContacts.contactAdded')
                    if (this.contactData) {
                        await this.updateContact({
                            id: this.id,
                            payload: {
                                ...{
                                    ...this.contactPayload,
                                    phone: this.contactPayload.phone ?
                                        !this.contactPayload.phone.includes("+1") ?
                                            "+1 " + this.contactPayload.phone :
                                            this.contactPayload.phone : '',
                                    ...(this.accidentalContact ? {
                                        injury_status: this.contactPayload.injury_status,
                                        ambulance: this.contactPayload.ambulance
                                    } : {})
                                },
                                id: this.contactData.id
                            }
                        })
                        successMsg = this.$t('safetyContacts.contactUpdated')
                    }
                    else {
                        await this.addContact({
                            id: this.id,
                            payload: {
                                ...this.contactPayload,
                                phone: this.contactPayload.phone ?
                                    !this.contactPayload.phone.includes("+1") ?
                                        "+1 " + this.contactPayload.phone :
                                        this.contactPayload.phone : '',
                                ...(this.accidentalContact ? {
                                    injury_status: this.contactPayload.injury_status,
                                    ambulance: this.contactPayload.ambulance
                                } : {})
                            }
                        })
                    }
                    await this.setNotification({
                        msg: successMsg,
                        type: "success",
                        color: "green",
                    });
                    this.$emit("contactUpdated", true)
                    this.resetPopup()
                    this.setLoader(false)
                }
                else {
                    let error = {};
                    nullKeys.forEach((x) => {
                        error[x] = [this.$t('safetyShared.fieldRequired')];
                    });
                    throw error;
                }
            }
            catch (error) {
                if (typeof error === "object") {
                    this.errors = error;
                    // eslint-disable-next-line no-ex-assign
                }
                this.setLoader(false);
            }
        },
    },
    watch: {
        contactData() {
            if (this.contactData) {
                this.contactPayload = JSON.parse(JSON.stringify(this.contactData))
                if (this.contactData.phone) this.contactPayload.phone = this.contactData.phone.startsWith("+1") ? this.contactData.phone.slice(2).trim() : this.contactData.phone
            }
        }
    },
}
</script>